export default [
  {
    component: "StackImages",
    data: {
      title: "chapter-2.slice-1.title",
      description: "chapter-2.slice-1.description",
      images: [
        {
          alt: "chapter-2.slice-1.image-1.alt",
          src: "chapter-2.slice-1.image-1.src",
          // src: require('@/assets/images/chapter-2_slice-1_image-1.jpg')
        },
        {
          alt: "chapter-2.slice-1.image-2.alt",
          src: "chapter-2.slice-1.image-2.src",
          // src: require('@/assets/images/chapter-2_slice-1_image-2.jpg')
        },
        {
          alt: "chapter-2.slice-1.image-3.alt",
          src: "chapter-2.slice-1.image-3.src",
          // src: require('@/assets/images/chapter-2_slice-1_image-3.jpg')
        },
        {
          alt: "chapter-2.slice-1.image-4.alt",
          src: "chapter-2.slice-1.image-4.src",
          // src: require('@/assets/images/chapter-2_slice-1_image-4.jpg')
        },
        {
          alt: "chapter-2.slice-1.image-5.alt",
          src: "chapter-2.slice-1.image-5.src",
          // src: require('@/assets/images/chapter-2_slice-1_image-5.jpg')
        }
      ]
    }
  },
  {
    component: "CarouselSplit",
    data: {
      title: "chapter-2.slice-2.title",
      carousel: [
        {
          image: {
            alt: "chapter-2.slice-2.image-1.alt",
            src: "chapter-2.slice-2.image-1.src",
            // src: require('@/assets/images/chapter-2_slice-2_image-1.jpg')
          },
        }, {
          image: {
            alt: "chapter-2.slice-2.image-2.alt",
            src: "chapter-2.slice-2.image-2.src",
            // src: require('@/assets/images/chapter-2_slice-2_image-2.jpg')
          },
        }, {
          image: {
            alt: "chapter-2.slice-2.image-3.alt",
            src: "chapter-2.slice-2.image-3.src",
            // src: require('@/assets/images/chapter-2_slice-2_image-3.jpg')
          },
        }
      ]
    }
  },
  {
    component: "TextImage",
    data: {
      text: {
        description: "chapter-2.slice-3.text.description",
        quote: "chapter-2.slice-3.text.quote",
        author: "chapter-2.slice-3.text.author",
      },
      image: {
        alt: "chapter-2.slice-3.image.alt",
        src: "chapter-2.slice-3.image.src",
        // src: require('@/assets/images/chapter-2_slice-3_image-1.jpg')
      },
    }
  },
  {
    component: "CarouselFull",
    data: {
      title: "chapter-2.slice-4.title",
      text: "chapter-2.slice-4.text",
      backgroundColor: "white",
      carousel: [
        {
          image: {
            alt: "chapter-2.slice-4.image-1.alt",
            src: "chapter-2.slice-4.image-1.src",
            // src: require('@/assets/images/chapter-2_slice-4_image-1.jpg')
          },
        }, {
          image: {
            alt: "chapter-2.slice-4.image-2.alt",
            src: "chapter-2.slice-4.image-2.src",
            // src: require('@/assets/images/chapter-2_slice-4_image-2.jpg')
          },
        }, {
          image: {
            alt: "chapter-2.slice-4.image-3.alt",
            src: "chapter-2.slice-4.image-3.src",
            // src: require('@/assets/images/chapter-2_slice-4_image-3.jpg')
          },
        }, {
          image: {
            alt: "chapter-2.slice-4.image-4.alt",
            src: "chapter-2.slice-4.image-4.src",
            // src: require('@/assets/images/chapter-2_slice-4_image-4.jpg')
          },
        }, {
          image: {
            alt: "chapter-2.slice-4.image-5.alt",
            src: "chapter-2.slice-4.image-5.src",
            // src: require('@/assets/images/chapter-2_slice-4_image-5.jpg')
          },
        }, {
          image: {
            alt: "chapter-2.slice-4.image-6.alt",
            src: "chapter-2.slice-4.image-6.src",
            // src: require('@/assets/images/chapter-2_slice-4_image-6.jpg')
          },
        }
      ]
    }
  },
  {
    component: "VerticalGallery",
    data: {
      title: 'chapter-2.slice-5.title',
      description: 'chapter-2.slice-5.description',
      images: [
        // {
        //   alt: "chapter-2.slice-5.image-1.alt",
        //   src: "chapter-2.slice-5.image-1.src",
        //   // src: require('@/assets/images/chapter-2_slice-5_image-1.jpg'),
        //   offset: -10,
        //   width: 82.26,
        //   speed: 0.5,
        //   ratio: 1317/1233,
        // },
        {
          alt: "chapter-2.slice-5.image-2.alt",
          src: "chapter-2.slice-5.image-2.src",
          // src: require('@/assets/images/chapter-2_slice-5_image-2.jpg'),
          offset: -10, 
          width: 60.55,
          speed: -0.5,
          ratio: 684/906,
        },
        {
          alt: "chapter-2.slice-5.image-3.alt",
          src: "chapter-2.slice-5.image-3.src",
          // src: require('@/assets/images/chapter-2_slice-5_image-3.jpg'),
          offset: -10,
          width: 73.7,
          speed: 1,
          ratio: 1180/1107,
        },
        {
          alt: "chapter-2.slice-5.image-4.alt",
          src: "chapter-2.slice-5.image-4.src",
          // src: require('@/assets/images/chapter-2_slice-5_image-4.jpg'),
          offset: -10,
          // width: 82.26,
          width: 60.55,
          speed: -0.75,
          ratio: 944/1232,
        },
        {
          alt: "chapter-2.slice-5.image-5.alt",
          src: "chapter-2.slice-5.image-5.src",
          // src: require('@/assets/images/chapter-2_slice-5_image-5.jpg'),
          offset: -10,
          width: 59.5,
          speed: 0.5,
          ratio: 952/1232,
        }
      ]  
    }
  },
  {
    component: "NextChapter",
    data: {
      image: {
        alt: "chapter-2.next.image.alt",
        src: "chapter-2.next.image.src",
        // src: require('@/assets/images/chapter-2_next.jpg')
      },
      nextChapter: "chapter-2.next.title"
    }
  }
]